import { ArticleTypeCalculationMethod, ArticleTypeCalculationPrecission, AttributeGroupUsage } from './../../../article-types/article-type.model';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ConfigurationService, DialogService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { IdGeneratorService } from 'src/common/services/id-generator.service';
import { environment } from 'src/environments/environment';
import { ArticleType, ArticleTypeAttributeType } from 'src/erp-articles/article-types/article-type.model';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { CostsPrice, Description, Price, RetailPrice, RetailPriceCalculationValue } from 'src/erp-articles/erp-common/erp-common.model';
import { Article } from '../../catalog.model';
import { BasicArticleRetailPrices, SaveArticleResponse } from './../../catalog.model';
import { DescriptionEditorComponent } from './description-editor/description-editor.component';
import { PriceEditorComponent } from './price-editor/price-editor.component';

@Component({
  selector: 'app-article-editor',
  templateUrl: './article-editor.component.html',
  styleUrls: ['./article-editor.component.scss']
})
export class ArticleEditorComponent implements OnInit {

  hideVatPrices = true;
  priceScale = 2;
  responseMessages = new Array<ResponseMessage>();

  attributeUsageArticle = AttributeGroupUsage.ARTICLE;

  articleTypeAttributeType: ArticleTypeAttributeType;

  attributeGroupsArtice = new Array();

  articleType: ArticleType;

  article: Article;

  basicArticleRetailPrices = new BasicArticleRetailPrices({});

  confirmDisabled = false;

  formGroup = new FormGroup({});
  // sub FormGroup to react on attribute changes
  attributesFormGroup = new FormGroup({});

  descriptionDisplayedColumns: string[] = ['usage', 'content', 'commands'];
  descriptionsDataSource: MatTableDataSource<Description>;

  costsPricesDataSource: MatTableDataSource<CostsPrice>;

  retailPriceVatColumn = 'price-vat';
  retailPriceTaxRateColumn = 'tax-rate';
  retailPricesDisplayedColumns: string[] = ['valid-from', 'valid-until', 'price-net', this.retailPriceTaxRateColumn, this.retailPriceVatColumn, 'reference-date', 'commands'];
  retailPricesDataSource: MatTableDataSource<RetailPrice>;

  retailPricesBasicArticleDisplayedColumns: string[] = ['valid-from', 'valid-until', 'price-net', 'tax-rate', this.retailPriceVatColumn, 'reference-date'];
  retailPricesBasicArticleDataSource: MatTableDataSource<RetailPrice>;

  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource: MatTableDataSource<Description>;


  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this.liveAnnouncer.announce('Sorting cleared');
    }
  }


  constructor(
    private liveAnnouncer: LiveAnnouncer,
    public translationService: TranslationService,
    public cps: ConfigurationService,
    public dialogRef: MatDialogRef<ArticleEditorComponent>,
    private articleTypeService: ArticleTypeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogService: DialogService,
    private http: HttpService,
    private idGenerator: IdGeneratorService
  ) {
    this.priceScale = this.cps.getClientParamValue('erp.use-three-digit-prices', 'false') === 'true' ? 3 : 2;
    this.hideVatPrices = this.cps.getClientParamValue('erp.hide-vat-prices', 'false') === 'true';
    this.buildPriceColumns();

    this.articleType = data.articleType.completeArticleType;
    this.article = data.article;

    this.findArticleTypeByArticle(this.article);

    if (this.article.retailPricesFromBasicArticle === true && this.article.retailPricesFromBasicArticle === true) {
      this.loadRetailPricesFromBasicArticle();
    }

    this.dataSource = new MatTableDataSource(this.article.descriptions);

    this.formGroup.addControl('id', new FormControl(this.article.id, []));
    this.formGroup.addControl('archived', new FormControl(this.article.archived, []));
    this.formGroup.addControl('retailPricesFromBasicArticle', new FormControl(this.article.retailPricesFromBasicArticle, []));


    this.formGroup.addControl('attributes', this.attributesFormGroup);

  }

  findArticleTypeByArticle(article: Article) {
    if (article != null && this.articleType === null) {
      this.articleType = this.articleTypeService.getById(article.articleTypeId).completeArticleType;
    }
  }

  ngOnInit(): void {

		this.descriptionsDataSource = this.createDescriptionDataSource();
    this.retailPricesDataSource = this.createRetailPricesDataSource();
    this.costsPricesDataSource = this.createCostsPricesDataSource();
    this.loadRetailPricesFromBasicArticle();

    this.attributeGroupsArtice = this.articleType.attributeGroups.filter (g => g.usage === AttributeGroupUsage.ARTICLE);

    this.attributesFormGroup.valueChanges.subscribe(values => {
      if (this.article.retailPricesFromBasicArticle === true) {
        this.loadRetailPricesFromBasicArticle();
      }
    });

    this.formGroup.controls.archived.valueChanges.subscribe(value => {
      this.article.archived = value;
    });

    this.formGroup.controls.retailPricesFromBasicArticle.valueChanges.subscribe(value => {
      this.article.retailPricesFromBasicArticle = value;
      if (value === true) {
        this.loadRetailPricesFromBasicArticle();
      }
    });


    this.formGroup.valueChanges.subscribe(values => {
      // currently no form values to handle
    });

    this.formGroup.statusChanges.subscribe(newStatus => {
      this.confirmDisabled = !this.formGroup.valid;
    });

    this.formGroup.markAllAsTouched();
    this.confirmDisabled = !this.formGroup.valid;
  }

  onClose() {
    this.responseMessages.splice(0, this.responseMessages.length);
    this.dialogRef.close(null);
  }

  onConfirm() {
    this.confirmDisabled = true;
    this.article.fillValuesFromValuesMap();
    this.article.priceContainer?.costsPrices?.forEach(cp => cp.fillValuesFromValuesMap());
    this.responseMessages.splice(0, this.responseMessages.length);
    this.http.postWithContext<SaveArticleResponse>(environment.erpArticleEndpoint + '/saveArticle', this.article).subscribe(response => {
      console.log('onConfirm', response);
      if (response.status === ResponseStatus.SUCCESS) {
        this.dialogRef.close(response.articleId);
      } else {
        this.responseMessages.push(...response.responseMessages);
      }
      this.confirmDisabled = false;
    }, error => {
      console.log('error is', error);
      this.confirmDisabled = false;
    });

  }

  addDescription() {
    this.dialogService.openDefault(DescriptionEditorComponent, { article: this.article })
      .afterClosed().subscribe(value => {
        this.descriptionsDataSource = this.createDescriptionDataSource();
      });
  }

  editDescription(description: Description) {
    this.dialogService.openDefault(DescriptionEditorComponent, { description: description })
      .afterClosed().subscribe(value => {
        this.descriptionsDataSource = this.createDescriptionDataSource();
      });
  }

  removeDescription(description: Description) {
    this.dialogService.showConfirm('erp.ui.article-editor.dialog.remove-description.title', 'erp.ui.article-editor.dialog.remove-description.message')
      .afterClosed()
      .subscribe(confirmed => {
        if (confirmed) {
          description.deleted = true;
          this.descriptionsDataSource = this.createDescriptionDataSource();
        }
      });
  }

  addRetailPrice() {
    this.dialogService.openDefault(PriceEditorComponent, { article: this.article, articleType: this.articleType, price: new RetailPrice({ id: this.idGenerator.getNextId() }) })
      .afterClosed().subscribe(value => {
        if (value != null) {
          this.article.priceContainer.retailPrices.push(value);
          this.retailPricesDataSource = this.createRetailPricesDataSource();
        }
      });
  }

  editRetailPrice = (index: number): void => {
    this.dialogService.openDefault(PriceEditorComponent, { article: this.article, price: this.article.priceContainer.retailPrices[index], articleType: this.articleType })
      .afterClosed().subscribe(value => {
        if (value != null) {
          this.retailPricesDataSource = this.createRetailPricesDataSource();
        }
      });
  }

  removeRetailPrice = (index: number): void => {
    const price = this.article.priceContainer.retailPrices[index];
    this.dialogService.showConfirm('erp.ui.article-editor.dialog.remove-retailprice.title', 'erp.ui.article-editor.dialog.remove-retailprice.message')
      .afterClosed()
      .subscribe(confirmed => {
        if (confirmed) {
          price.deleted = true;
          this.retailPricesDataSource = this.createRetailPricesDataSource();
        }
      });
  }

  addCostsPrice() {
    this.dialogService.openDefault(PriceEditorComponent, { article: this.article, articleType: this.articleType, price: new CostsPrice({ id: this.idGenerator.getNextId() }) })
      .afterClosed().subscribe(value => {
        if (value != null) {
          this.article.priceContainer.costsPrices.push(value);
          this.costsPricesDataSource = this.createCostsPricesDataSource();
        }
      });
  }

  editCostsPrice = (price: Price): void =>  {
    this.dialogService.openDefault(PriceEditorComponent, { article: this.article, price: price, articleType: this.articleType, mode: 'costs' })
      .afterClosed().subscribe(value => {
        if (value != null) {
          this.costsPricesDataSource = this.createCostsPricesDataSource();
        }
      });
  }

  removeCostsPrice = (price: Price): void => {
    this.dialogService.showConfirm('erp.ui.article-editor.dialog.remove-costsprice.title', 'erp.ui.article-editor.dialog.remove-costsprice.message')
      .afterClosed()
      .subscribe(confirmed => {
        if (confirmed) {
          price.deleted = true;
          this.costsPricesDataSource = this.createCostsPricesDataSource();
        }
      });
  }

  private buildPriceColumns() {
    if (this.hideVatPrices) {
      this.retailPricesDisplayedColumns.splice(this.retailPricesDisplayedColumns.indexOf(this.retailPriceVatColumn), 1);
      this.retailPricesDisplayedColumns.splice(this.retailPricesDisplayedColumns.indexOf(this.retailPriceTaxRateColumn), 1);
      this.retailPricesBasicArticleDisplayedColumns.splice(this.retailPricesBasicArticleDisplayedColumns.indexOf(this.retailPriceVatColumn), 1);
      this.retailPricesBasicArticleDisplayedColumns.splice(this.retailPricesBasicArticleDisplayedColumns.indexOf(this.retailPriceTaxRateColumn), 1);
    }
  }

  private loadRetailPricesFromBasicArticle() {
    const values = {};
    for (const k of this.article.valuesMap.keys()) {
      values[k] = this.article.valuesMap.get(k);
    }
    this.http.postWithContext<number>(environment.erpArticleEndpoint + '/getAllBasicArticleRetailPricesByArticleDetails', {articleTypeId: this.article.articleTypeId, values: values}).subscribe(response => {
        console.log('loadRetailPricesFromBasicArticle', response);
        this.basicArticleRetailPrices = new BasicArticleRetailPrices(response);
        this.retailPricesBasicArticleDataSource = this.createRetailPricesBasicArticleDataSource();
        this.retailPricesDataSource = this.createRetailPricesDataSource();
    }, error => {
      console.log('error is', error);
    });
  }

  private createDescriptionDataSource(): MatTableDataSource<Description> {
    return new MatTableDataSource(this.article.descriptions.filter(d => !d.deleted));
  }

  private createRetailPricesDataSource(): MatTableDataSource<RetailPrice> {
    const now = new Date();
    now.setHours(0);
    now.setMilliseconds(0);
    now.setMinutes(0);
    now.setSeconds(0);
    const retailPrices = new Array<RetailPrice>();
    // handle RetailPrices with useBasicArticlePrice===true
    for (const retailPrice of this.article.priceContainer.retailPrices) {
      if (!retailPrice.deleted) {
        if (!retailPrice.useBasicPrice) {
          const calculatedRetailPrice = new RetailPrice(retailPrice);
          calculatedRetailPrice.validPeriod = retailPrice.validPeriod;
          this.calculateRetailPriceTotal(calculatedRetailPrice);
          retailPrices.push(calculatedRetailPrice);
        } else {
          const basicArticleRetailPrice = this.basicArticleRetailPrices.findValidRetailPrice(now);
          const newPrice = new RetailPrice({
            id: retailPrice.id,
            deleted: retailPrice.deleted,
            referenceDate: retailPrice.referenceDate,
            taxRate: retailPrice.taxRate,
            priceNet: basicArticleRetailPrice?.priceNet,
            priceVat: basicArticleRetailPrice?.priceVat,
            valuesMap: retailPrice.valuesMap,
            useBasicPrice: retailPrice.useBasicPrice,
            calculationValues: retailPrice.calculationValues
          });
          newPrice.validPeriod = retailPrice.validPeriod;
          this.calculateRetailPriceTotal(newPrice);
          retailPrices.push(newPrice);
        }
      }
    }
    return new MatTableDataSource(retailPrices);
  }

  private createRetailPricesBasicArticleDataSource(): MatTableDataSource<RetailPrice> {
    const retailPrices = new Array<RetailPrice>();
    for (const retailPrice of this.basicArticleRetailPrices.priceContainer.retailPrices) {
      if (!retailPrice.deleted) {
        const newPrice = new RetailPrice({
          id: retailPrice.id,
          deleted: retailPrice.deleted,
          referenceDate: retailPrice.referenceDate,
          taxRate: retailPrice.taxRate,
          priceNet: retailPrice.priceNet,
          priceVat: retailPrice.priceVat,
          valuesMap: retailPrice.valuesMap,
          useBasicPrice: retailPrice.useBasicPrice,
          calculationValues: retailPrice.calculationValues
        });
        newPrice.validPeriod = retailPrice.validPeriod;
        this.calculateRetailPriceTotal(newPrice);
        retailPrices.push(newPrice);
      }
    }
    return new MatTableDataSource(retailPrices);
  }

  private createCostsPricesDataSource(): MatTableDataSource<CostsPrice> {
    return new MatTableDataSource(this.article.priceContainer.costsPrices.filter(d => !d.deleted));
  }

  private calculateRetailPriceTotal(retailPrice: RetailPrice) {
    // Execute Calculaction Rules
    if (this.articleType != null && retailPrice.calculationValues != null) {
      let totalPriceNet = retailPrice.priceNet;
      for (const articleTypeCalculationRule of this.articleType.calculationRules) {
        let calculationValue = retailPrice.getValueByRuleId(articleTypeCalculationRule.id);
        if ( calculationValue == null) {
          console.log('No CalculationValue found by Rule', articleTypeCalculationRule);
          calculationValue = new RetailPriceCalculationValue({count: 0, value: 0});
        }
        if (articleTypeCalculationRule.precission === ArticleTypeCalculationPrecission.ATTRIBUTE) {
          const count = this.article.valuesMap.get('' + articleTypeCalculationRule.attributeId);
          calculationValue.count = Number.parseFloat(count);
        }
        calculationValue.calculate();
        if (articleTypeCalculationRule.method === ArticleTypeCalculationMethod.ADD) {
          totalPriceNet = totalPriceNet + calculationValue.total;
        } else if (articleTypeCalculationRule.method === ArticleTypeCalculationMethod.SUBTRACT) {
          totalPriceNet = totalPriceNet - calculationValue.total;
        }
      }
      retailPrice.priceNet = totalPriceNet;
    }
  }
}
